import { ElementRef, Injectable } from '@angular/core';

@Injectable()
export class NumpadScrollService {
    closingNumpadRef?: ElementRef<HTMLElement>;

    getClosingNumpadRect(): DOMRect | undefined {
        return this.closingNumpadRef?.nativeElement.getBoundingClientRect() ?? undefined;
    }
}
